import { SMLRouteNames } from '../../routing/sml/SMLRoutes';

/** The last part of the editor route: `/catalog/song/<uuid>/cover`. */
export const COVER_EDITOR_SEGMENT = 'cover';

interface CoverEditorPathOptions {
  /** The artist of the row; the web switcher reads it. */
  accountId?: number | null;
  /** The page that opened the editor (a path inside the app): "Back" returns to it. */
  from?: string;
}

/**
 * The path of the cover editor of one song (design cover-editor b1):
 * `/catalog/song/<uuid>/cover[?accountId=<id>][&from=<path>]`. The router adds `/app`.
 */
export function coverEditorPath(catalogItemUuid: string, options: CoverEditorPathOptions = {}): string {
  const query = new URLSearchParams();
  if (options.accountId !== undefined && options.accountId !== null) {
    query.set('accountId', String(options.accountId));
  }
  if (options.from !== undefined && options.from !== '') {
    query.set('from', options.from);
  }
  const search = query.toString();
  return `/${SMLRouteNames.catalog}/song/${encodeURIComponent(catalogItemUuid)}/${COVER_EDITOR_SEGMENT}${
    search === '' ? '' : `?${search}`
  }`;
}

/**
 * The page that "Back" opens: `from` when it is a path inside the app (it starts with one `/` and
 * holds no scheme and no host), else null (the caller opens the song page). A link from outside
 * must not send the user to another site. Pure.
 */
export function safeReturnPath(from: string | null | undefined): string | null {
  if (from === null || from === undefined || from === '') {
    return null;
  }
  // eslint-disable-next-line no-control-regex -- a control character is never a part of a path of the app
  if (!from.startsWith('/') || from.startsWith('//') || from.includes('\\') || /[\u0000-\u001f]/.test(from)) {
    return null;
  }
  return from;
}
